import React from 'react';
import { useAuth } from './context/AuthContext';
import App from './App';
import MusteriPaneli from './components/musteri/MusteriPaneli';

// Kök ayrımı (2026-10-26): müşteri hesabı App'i HİÇ yüklemez — App'in sayaçları, ders özeti ve
// websocket'i müşteride çalışmaz (sunucu da müşteriyi /api/musteri/* dışına 403 ile kapatır).
// Giriş ekranı ve oturum doğrulaması App'te kalır (rol oturum açıldıktan sonra bilinir).
export default function KokUygulama() {
  const { kullanici, yukleniyor } = useAuth();
  if (!yukleniyor && kullanici && kullanici.rol === 'musteri') return <MusteriPaneli />;
  return <App />;
}
